import React, { useState } from "react";
import styles from "./SideControl.module.css";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";
import ViewInArRoundedIcon from "@mui/icons-material/ViewInArRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { Badge, Popover, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SideControl = ({ controlTabIndex, setControlTabIndex }) => {
    // const handleSelect = (e) => {};
    const isSmallScreen = useMediaQuery("(max-width:600px)");
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isNoti, setIsNoti] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setIsNoti(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <>
            <div className={styles.titleDiv}>
                <img src="/phicode_light.png" alt="phicode" width="100%" />
            </div>
            <div
                className={`${
                    isSmallScreen
                        ? styles.navMenuWrapperMobile
                        : styles.navMenuWrapper
                } flex-col-direction`}
            >
                <div className={`${styles.navMenu} flex-col-direction`}>
                    <div
                        className={`${
                            controlTabIndex === 0
                                ? styles.menuIconsActive
                                : styles.menuIcons
                        }`}
                        onClick={() => {
                            localStorage.setItem("cIndex", 0);
                            // setControlTabIndex(0)
                            navigate("/dashboard/");
                        }}
                    >
                        <img
                            src={
                                controlTabIndex === 0
                                    ? "/assets/icons/homef.png"
                                    : "/assets/icons/home.png"
                            }
                            alt="home"
                            width="100%"
                        />
                    </div>

                    <div
                        className={`${
                            controlTabIndex === 1
                                ? styles.menuIconsActive
                                : styles.menuIcons
                        }`}
                        onClick={() => {
                            // localStorage.setItem("cIndex", 1)
                            // setControlTabIndex(1)
                            navigate("/dashboard/maps/4");
                        }}
                    >
                        <img
                            src={
                                controlTabIndex === 0
                                    ? "/assets/icons/location (1).png"
                                    : "/assets/icons/location.png"
                            }
                            alt="location"
                            width="100%"
                        />
                    </div>

                    {/* <div
                        className={`${
                                controlTabIndex === 3 ? styles.menuIconsActive : styles.menuIcons
                        }`}
                        onClick={() => setControlTabIndex(2)}
                    >
                        <img src="/assets/icons/3d.png" alt="3d" width="100%" />
                    </div> */}
                    <div
                        className={styles.menuIcons}
                        aria-describedby={id}
                        variant="contained"
                        onClick={handleClick}
                    >
                        <Badge
                            variant="dot"
                            color="secondary"
                            invisible={isNoti}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                        >
                            <img
                                src="/assets/icons/notification.png"
                                alt="location"
                                width="100%"
                            />
                        </Badge>
                    </div>
                    <div className={styles.menuIcons}>
                        <img
                            src="/assets/icons/setting.png"
                            alt="location"
                            width="100%"
                        />
                    </div>
                </div>
                <div className={`${styles.navMenu} flex-col-direction`}>
                    <div className={styles.menuIcons} onClick={()=>navigate("/dashboard/profile")}>
                        <img
                            src="/assets/icons/user.png"
                            alt="location"
                            width="100%"
                        />
                    </div>

                    <div
                        className={styles.menuIcons}
                        onClick={() => navigate("/")}
                    >
                        <img
                            src="/assets/icons/logout.png"
                            alt="location"
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Typography sx={{ p: 2 }}>
                    <div>notification 1</div>
                    <div>notification 2</div>
                    <div>notification 3</div>
                </Typography>
            </Popover>
        </>
    );
};

export default SideControl;
